@if (component.data$ | async; as data) {
  @if (isVisible && data.content) {
    <div class="banner">
      <div class="banner-container">
        <div class="scrolling-text-wrapper">
          <div class="scrolling-text" [innerHTML]="bypassSecurityTrustHtml(data.content | cxSupplementHashAnchors)"></div>
        </div>
        <button
          type="button"
          class="close"
          title="{{ 'common.close' | cxTranslate }}"
          [attr.aria-label]="'common.close' | cxTranslate"
          (click)="hideBanner(data.uid)"
          >
          <span aria-hidden="true">
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </span>
        </button>
      </div>
    </div>
  }
}
